module.exports = __webpack_public_path__ + "img/bg_pop_top_small.75a172dd.png";